import { Link } from "react-router-dom";

export function Logo({ dark = false, className = "" }) {
  return (
    <Link to="/" className={`flex shrink-0 items-center gap-2.5 ${className}`} data-testid="header-tfm-logo">
      <img
        src="/tfm-logo.jpg"
        alt="The Future Marketing"
        className={`h-11 w-auto object-contain ${dark ? "rounded-lg bg-white p-1.5" : ""}`}
      />
      <span className="flex flex-col leading-tight">
        <span
          data-testid="company-name-text"
          className={`whitespace-nowrap font-display text-sm font-extrabold tracking-tight sm:text-[15px] ${dark ? "text-white" : "text-[#0B1B3D]"}`}
        >
          The Future Marketing
        </span>
        <span className="whitespace-nowrap font-spec text-[9px] font-medium uppercase tracking-[0.16em] text-[#10B981] sm:text-[10px]">
          Premium Flooring &amp; Matting
        </span>
      </span>
    </Link>
  );
}
